import './firstdiv.css';
import IMAGES from '../../../images/images';

export default function FirstDiv() {
    return (
        <div className="aboutMe">
            <div className="about__content">

                <img src={IMAGES.omotola_pp} alt="" />
                <div className="about__text">
                    <div className="about_textPar1">
                        <p id="about__paragraph">
                        Hello, and welcome to my portfolio project I built with React, entirely from scratch. I’m Omotola a full-stack software developer, a product designer, an architect(originally by training) , and a cloud tech enthusiast.
                        </p>
                    </div>
                    <div className="about_textPar1">
                        <p id="about__paragraph">
                        Originally a trained architect with a masters degree in Environmental design from the University of Lagos, Akoka. Building products and solving problems always has been an integral aspect of my core training and interest. I'm mostly self-taught in my Software Engineering journey, with foundations off the Codecademy platform, in combination with multiple online resources and documentations and do work full time in tech now.
                        </p>
                    </div>
                    <div className="about_textPar1">
                        <p id="about__paragraph">
                        Getting accepted Into The Google African Developers Scholarship Program was the beginning on my Cloud engineering journey, where I took advantage of the Google x Andela sponsored program to learn about the Google Cloud Platform where I developed my skill and experience on core GCP infrastructure, Architecting with GCE, Kubernetes engine, Managing cloud resources, setting up and configuring cloud environment, Terraform, deploying and managing cloud environments and currently, prepping for certifications.
                        </p>
                    </div>
                    <div className="about_textPar1">
                        <p id="about__paragraph">
                        I recently picked up an interest in technical writing on Medium, where I share my knowledge and experience on software development and cloud technology.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
